import React from 'react';
import range from 'lodash/range';
import moment, { Moment as MomentType } from 'moment';
import s from './HeaderDropdowns.scss';

export interface Props {
  month: MomentType;
  onMonthSelect: (month, value) => void;
  onYearSelect: (year, value) => void;
}

const HeaderDropdowns: React.FC<Props> = ({
  month: date,
  onMonthSelect,
  onYearSelect,
}) => {
  const currentYear = new Date().getFullYear();
  const selectedMonth = date.format('MMMM');
  const selectedYear = date.format('YYYY');

  const handleSelectYear = value => {
    onYearSelect(date, value.target.value);
  };
  const handleSelectMonth = value => {
    onMonthSelect(date, value.target.value);
  };

  return (
    <div className={s['order-select']}>
      <select
        className={s['month']}
        onChange={handleSelectMonth}
        defaultValue={selectedMonth}
      >
        {moment.months().map(m => (
          <option key={m} value={m}>
            {m}
          </option>
        ))}
      </select>
      <select
        className={s['year']}
        onChange={handleSelectYear}
        defaultValue={selectedYear}
      >
        {range(currentYear, currentYear + 5).map(y => (
          <option key={y} value={y}>
            {y}
          </option>
        ))}
      </select>
    </div>
  );
};
HeaderDropdowns.displayName = 'HeaderDropdowns';

export default HeaderDropdowns;
